import {
    AmenitiesCriterion,
    BrandsCriterion,
    MinimumStayNightsCriterion,
    PriceRangeCriterion,
    RoomsAndBedsCriterion,
    StyleCriterion
} from '../../../../graphql'

export interface MoreFilters {
    priceRangeCriterion: PriceRangeCriterion,
    roomsAndBedsCriterion: RoomsAndBedsCriterion,
    brandsCriterion: BrandsCriterion,
    amenitiesCriterion: AmenitiesCriterion,
    minimumStayNightsCriterion: MinimumStayNightsCriterion,
    styleCriterion?: StyleCriterion
}

export function defaultMoreFilters(): MoreFilters {
    return {
        brandsCriterion: {
            brandIds: []
        },
        amenitiesCriterion: {
            selectedAmenityIds: []
        },
        priceRangeCriterion: {
            minimum: toCurrency(0),
            maximum: toCurrency(100000)
        },
        roomsAndBedsCriterion: {
            beds: 0,
            bedrooms: 0,
            bathrooms: 0
        },
        minimumStayNightsCriterion: {
            minimumStayNights: 0,
        },
        styleCriterion:  {
            propertyStyles: []
        }
    }
}

export function toCurrency(value: number, currencyCode: string = 'USD') {
    return {
        currency: currencyCode,
        amountMicros: value * 1000000
    }
}
